import * as React from 'react';
import * as Immutable from 'immutable';
import LocationCodeInput from './LocationCodeInput';
import popOverFactory from 'common/components/core/popover/popOverFactory';
import Icon from 'common/components/core/icon';
import { memoizedImmutable } from 'common/utils/Memoizer';
import { MasterLocation } from 'common/models/internal/MasterLocation';

const LocationCodeInputWithPopover = popOverFactory({
    Component: LocationCodeInput
});

class EntityLocationCodeInput extends React.PureComponent {
    onLocationChange = value => {
        const {
            onChange,
            name,
            existingLocation,
            teams,
            clientId
        } = this.props;

        let modifiedValue = value;
        if (modifiedValue) {
            if (Array.isArray(modifiedValue)) {
                modifiedValue = Immutable.List(modifiedValue);
            } else {
                const { code, __isNew__ } = value;
                if (__isNew__) {
                    // Case where a new option is created
                    const selectedTeam = this.getTeamDetails(teams);
                    let selectedTeamId;
                    if (selectedTeam) {
                        ({ teamId: selectedTeamId } = selectedTeam);
                    }
                    // if the location was already present then we only keep the address
                    // and latlng field with the new code provided.
                    let addressFields = {};
                    if (existingLocation) {
                        addressFields = {
                            address: existingLocation.address
                                ? existingLocation.address.toJS()
                                : null,
                            latLng: existingLocation.latLng
                                ? existingLocation.latLng.toJS()
                                : null
                        };
                    }
                    modifiedValue = MasterLocation.fromJS({
                        clientId,
                        type: 'CLIENT',
                        name: name ? name : code,
                        teams: selectedTeamId ? [selectedTeamId] : [],
                        ...addressFields
                    }).setCode(code);
                }
            }
        } else {
            modifiedValue = existingLocation
                ? existingLocation.setCode(null)
                : MasterLocation.fromJS({
                      type: 'CLIENT'
                  }).setCode(null);
        }
        onChange && onChange(modifiedValue);
    };

    @memoizedImmutable()
    getTeamDetails(teams) {
        const { teams: teamList } = this.props;
        return teams.size > 0 ? teamList.get(teams.get(0).teamId) : null;
    }

    getLocationFilters = input => {
        const { getLocationFilters, entity } = this.props;
        return getLocationFilters({ entity, input });
    };

    render() {
        const {
            clientId,
            getLocationFilters, // eslint-disable-line no-unused-vars
            onChange, // eslint-disable-line no-unused-vars
            popOverContent,
            warningMessage,
            theme,
            ...rest
        } = this.props;
        return (
            //@others-spread-end
            <div>
                <LocationCodeInputWithPopover
                    clientId={clientId}
                    getLocationFilters={this.getLocationFilters}
                    popOverContent={popOverContent}
                    isPopOverOpen={!!popOverContent}
                    onChange={this.onLocationChange}
                    {...rest}
                />
                {warningMessage ? (
                    <div className={theme.warningMessage}>
                        <Icon icon="alert" theme={theme} />
                        <span className={theme.warningText}>
                            {warningMessage}
                        </span>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default EntityLocationCodeInput;
